<template>

</template>

<script>

export default {
  name: "AnnounceDetails",
  data(){
    return{
      info:{}
    }
  },
  methods:{
    // getDetails(id) {
    //   getAction('/announce/details', {id: id}).then(res => {
    //     if (res.success) {
    //       this.info = res.data;
    //     }
    //   })
    // }
  }
}
</script>

<style scoped>

</style>
